export default __webpack_public_path__ + "static/damixa-b6503390f2dfb9c917c7158b38d94628.mp4";